// extracted by mini-css-extract-plugin
export default {"wrapper":"nS4NxkFIpV","section":"XjWStYVKnR","fullscreenDrop":"lwKdo9CbRj"};